var React = require('react');

function NpTelephone674287000000 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m26 13c-1.9688 0.042969-2.8203 0.65234-4 2l-7 8c-1.4648 1.6719-2 4.2812-2 7 0 9.082 6.832 23.832 20 37s27.918 20 37 20c2.7188 0 5.3281-0.53516 7-2l8-7c1.3477-1.1797 1.957-2.0312 2-4 0.03125-1.4492-0.82812-2.8281-2-4l-11-11c-1.2344-1.2344-2.2969-2-4-2-1.7734 0-2.9062 0.90625-4 2l-4 4c-1.832 1.7656-3.1992 1.8984-5 1l-21-21c-0.89844-1.8008-0.76562-3.168 1-5l4-4c1.0938-1.0938 2-2.2266 2-4 0-1.7031-0.76562-2.7656-2-4l-11-11c-1.1719-1.1719-2.5508-2.0312-4-2z"}));
}

NpTelephone674287000000.defaultProps = {"width":"100pt","height":"100pt","version":"1.1","viewBox":"0 0 100 100"};

module.exports = NpTelephone674287000000;

NpTelephone674287000000.default = NpTelephone674287000000;
